import styled from 'styled-components';
import Button from 'components/ui-components/Button';

const HomepagePaginationDots = ({ totalSlides, activeIndex, onClick }) => {
  const dots = Array.from({ length: totalSlides }, (_, index) => index);

  return (
    <div className="p-0 m-0 splide-pagination-dots fl jc-c ai-c">
      {dots.map(index => (
        <PaginationButton
          key={index}
          className={`splide-pagination-dot mlr-5 ${
            index === activeIndex ? 'active' : ''
          }`}
          handleClick={() => onClick(index)}
          role="button"
          label={`Go to slide ${index + 1}`}
        />
      ))}
    </div>
  );
};

export default HomepagePaginationDots;

const PaginationButton = styled(Button)`
  width: 1rem;
  height: 1rem;
  padding: 0;
  border-radius: 50%;
  cursor: pointer;
  transition: background-color 0.3s ease;
  min-height: 1rem;
`;
